// extracted by mini-css-extract-plugin
export var csatScore = "_fr-5";
export var header = "_fr-1";
export var panelWrapper = "_fr-2";
export var postPreview = "_fr-3";
export var rightContent = "_fr-0";
export var wrappingText = "_fr-4";